import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { PATH_KEY_TO_POSITION } from '../../constants';
import CategoryList from '../CategoryList';
import Panel from '../shared/Panel';
import MenuEditor from './menu-editor';

const LEVEL = PATH_KEY_TO_POSITION['menuIdx'];

function MenuItem(props) {
  const {
    menu,
    menuIdx,
    acceptPreorders,
    setIsEditMode,
    isEditMode,
    isUpdatingMenuOrder,
    showMenuEditorLevel0,
    isExpanded,
    setIsExpanded,
    isAnyChildItemExpanded,
  } = props;

  const [showMenuEditor, setShowMenuEditor] = useState(false);
  const toggleEditor = () => {
    setShowMenuEditor(!showMenuEditor);
    setIsEditMode(!showMenuEditor);
  };

  return (
    <Panel
      key={`menu-item-panel-${menu.id}`}
      item={menu}
      level={LEVEL}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      onEdit={toggleEditor}
      isEditMode={isEditMode}
      isUpdatingMenuOrder={isUpdatingMenuOrder}
      showMenuEditorLevel0={showMenuEditorLevel0}
      isAnyChildItemExpanded={isAnyChildItemExpanded}
      topLevel={true}
    >
      {showMenuEditor ? (
        <MenuEditor
          menu={menu}
          acceptPreorders={acceptPreorders}
          menuIdx={menuIdx}
          onCancel={toggleEditor}
          setShowEditor={setShowMenuEditor}
        />
      ) : (
        <CategoryList
          menuIdx={menuIdx}
          parent={menu}
          setIsEditMode={setIsEditMode}
          isEditMode={isEditMode}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      )}
    </Panel>
  );
}

MenuItem.propTypes = {
  menu: PropTypes.object.isRequired,
  menuIdx: PropTypes.number.isRequired,
};

export default withTheme()(MenuItem);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/MenuList/menu-item.jsx